import React, { useState } from 'react';
import { X, CheckCircle, XCircle } from 'lucide-react';
import Button from '../ui/Button';

const AttendanceModal = ({ 
  isOpen, 
  onClose, 
  onUpdateAttendance,
  loading,
  selectedCount
}) => {
  const [selectedStatus, setSelectedStatus] = useState('present');

  const handleUpdate = () => {
    onUpdateAttendance(selectedStatus);
  };

  const handleClose = () => {
    setSelectedStatus('present');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn">
      <div className="bg-white rounded-[2.5rem] shadow-2xl shadow-blue-900/20 max-w-md w-full overflow-hidden animate-slideInUp border border-slate-100">
        {/* Header */}
        <div className="flex items-center justify-between p-8 border-b border-slate-100 bg-slate-50/50">
          <div>
            <h3 className="text-2xl font-black text-slate-800 tracking-tight">Mark Attendance</h3>
            <p className="text-slate-400 text-sm font-medium mt-1">Assign status to {selectedCount} selection(s)</p>
          </div>
          <button
            onClick={handleClose}
            className="p-3 hover:bg-white rounded-2xl text-slate-400 hover:text-rose-500 transition-all border border-transparent hover:border-slate-100 shadow-sm"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-8">
          <div className="grid grid-cols-1 gap-4 mb-8">
            <button
              onClick={() => setSelectedStatus('present')}
              className={`p-5 rounded-2xl border-2 transition-all flex items-center justify-between group ${
                selectedStatus === 'present'
                  ? 'border-blue-600 bg-blue-50/50 shadow-lg shadow-blue-600/10'
                  : 'border-slate-100 hover:border-blue-200 bg-slate-50/50'
              }`}
            >
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-all ${
                  selectedStatus === 'present' ? 'bg-blue-600 text-white' : 'bg-white text-emerald-500 shadow-sm'
                }`}>
                  <CheckCircle className="w-6 h-6" />
                </div>
                <div className="text-left">
                  <span className={`block font-black text-lg tracking-tight ${selectedStatus === 'present' ? 'text-blue-900' : 'text-slate-600'}`}>Present</span>
                  <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Mark as attendee</span>
                </div>
              </div>
              <div className={`w-6 h-6 rounded-full border-2 transition-all flex items-center justify-center ${
                selectedStatus === 'present' ? 'border-blue-600 bg-blue-600' : 'border-slate-200'
              }`}>
                {selectedStatus === 'present' && <div className="w-2 h-2 bg-white rounded-full"></div>}
              </div>
            </button>

            <button
              onClick={() => setSelectedStatus('absent')}
              className={`p-5 rounded-2xl border-2 transition-all flex items-center justify-between group ${
                selectedStatus === 'absent'
                  ? 'border-rose-600 bg-rose-50/50 shadow-lg shadow-rose-600/10'
                  : 'border-slate-100 hover:border-rose-200 bg-slate-50/50'
              }`}
            >
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-all ${
                  selectedStatus === 'absent' ? 'bg-rose-600 text-white' : 'bg-white text-rose-500 shadow-sm'
                }`}>
                  <XCircle className="w-6 h-6" />
                </div>
                <div className="text-left">
                  <span className={`block font-black text-lg tracking-tight ${selectedStatus === 'absent' ? 'text-rose-900' : 'text-slate-600'}`}>Absent</span>
                  <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Mark as non-attendee</span>
                </div>
              </div>
              <div className={`w-6 h-6 rounded-full border-2 transition-all flex items-center justify-center ${
                selectedStatus === 'absent' ? 'border-rose-600 bg-rose-600' : 'border-slate-200'
              }`}>
                {selectedStatus === 'absent' && <div className="w-2 h-2 bg-white rounded-full"></div>}
              </div>
            </button>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4">
            <button
              onClick={handleClose}
              className="flex-1 py-4 bg-slate-50 text-slate-500 font-black rounded-2xl hover:bg-slate-100 transition-all uppercase text-xs tracking-widest border border-slate-100"
            >
              Cancel
            </button>
            <button
              onClick={handleUpdate}
              disabled={loading}
              className="flex-1 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-black rounded-2xl shadow-lg shadow-blue-600/30 hover:shadow-blue-600/40 hover:scale-[1.02] active:scale-95 transition-all disabled:opacity-50 disabled:grayscale uppercase text-xs tracking-widest"
            >
              {loading ? 'Processing...' : 'Confirm'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceModal;
